














import { Component, Vue, Ref } from 'vue-property-decorator';
import ContextMoskit from '@/components/ContextOptions/ContextMoskit.vue';
import ContextIugu from '@/components/ContextOptions/ContextIugu.vue';
import VueContext from 'vue-context';

@Component({
  components: {
    ContextMoskit,
    ContextIugu,
  },
})
export default class FaturasContext extends Vue {
  @Ref() readonly menu!: VueContext;

  public open(event: MouseEvent, item: IFatura): void {
    this.menu.open(event, item);
  }

  public close(): void {
    this.menu.close();
    this.$emit('close');
  }
}
